import styled, { css } from 'styled-components';
import Logo from '../../../static/Logo.png';
import HIFGraphic from '../../../static/hif-graphic.jpg';

export const Nav = styled.div`
  margin-top: 50px;
  width: 100%;
  max-width: 1180px;
  margin-left: auto;
  margin-right: auto;
  position: absolute;
  z-index: 2000;
  padding: 0 20px;
  left: 0;
  right: 0;
  box-sizing: border-box;
  .Logo {
    max-width: 218.79px;
    height: 77px;
    background: transparent url(${Logo}) no-repeat;
    background-size: cover;
    text-indent: -9999px;
  }

  @media (max-width: 700px) {
    margin-top: 3vh;
    a:first-child {
      margin-left: 0;
    }
  }
`;

export const BGBlue = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  text-align: center;
  min-height: 750px;
  background: linear-gradient(180deg, #0a59ea 22%, #001e60 100%);

  .hifWrapper {
    width: 100%;
    max-width: 1680px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0 30px;

    img {
      width: 100%;
      max-width: 300px;
      position: relative;
      left: 5px;
    }

    @media (max-width: 700px) {
      flex-direction: column;
      height: 100%;
      min-height: none;
    }
  }

  .mbtTitle {
    margin-top: 30px;
    font-family: 'Roboto';
    font-weight: normal;
    color: white;
    font-size: 1.3em;
    margin-bottom: 50px;
    text-transform: uppercase;

    @media (max-width: 700px) {
      font-size: 6.2vw;
    }
  }

  .mbtMicrosoft {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center;

    @media (max-width: 700px) {
      img {
        width: 200px;
      }
    }

    img {
      width: 240px;
    }
  }

  .mbtExplore {
    background: white;
    color: #0a59ea;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 1em;
    font-family: 'Roboto';
    font-weight: bold;
    padding: 10px 20px;
    &:hover {
      color: black;
    }

    @media (max-width: 700px) {
      font-size: 1.2em;
    }
  }
`;

export const BG = styled.div`
  position: relative;
  height: 100vh;
  width: 100%;
  background-color: ${({ bgColor }) => (bgColor ? bgColor : '#fff')};
  text-align: center;
  min-height: 750px;

  .hifWrapper {
    width: 100%;
    max-width: 1680px;
    display: flex;
    margin-left: auto;
    margin-right: auto;
    height: 100%;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0 30px;

    @media (max-width: 700px) {
      flex-direction: column;
      height: 100%;
      min-height: none;
    }
  }

  .promoPhoto {
    width: 50%;
    background: transparent url(${HIFGraphic}) no-repeat;
    background-size: contain;
    background-position-y: center;
    &:after {
      content: '';
      display: block;
      padding-bottom: 100%;
    }
    @media (max-width: 700px) {
      width: 100%;
    }
  }

  .avail {
    font-family: 'GT America';
    font-weight: 300;
    font-style: italic;
    text-transform: uppercase;
    font-size: 1.8em;
    @media (max-width: 700px) {
      font-size: 6vw;
    }
  }

  .promoLinks {
    width: 50%;
    @media (max-width: 700px) {
      width: 100%;
    }

    img {
      width: 100%;
      max-width: 388px;
    }
  }

  .orderWrapper {
    margin: 20px 0 0 0;
    @media (max-width: 700px) {
      display: none;
    }
  }

  .orderTitle {
    font-family: 'GT America';
    font-weight: bold;
    font-style: italic;
    text-transform: uppercase;
  }

  .orderBtns {
    display: flex;
    justify-content: center;
    margin-top: 18px;
    a {
      position: relative;
      margin: 0 10px;
      font-family: 'GT America';
      font-weight: bold;
      font-style: italic;
      background: #000;
      border-radius: 30px;
      padding: 10px;
      color: #fff;
      text-decoration: none;
      font-size: 0.7em;
      display: inline-block;
      max-width: 250px;
      width: calc(50% - 30px);
      text-transform: uppercase;
      transition: all 180ms ease-out;
      img {
        position: absolute;
        left: 14px;
        top: 6px;
        width: auto;
        height: 18px;
      }
      @media (max-width: 700px) {
        /*
        color: #000;
        padding: 0; */
      }
      &:hover {
        background: linear-gradient(
          89.91deg,
          #6530cf 0.64%,
          #1032f2 23.92%,
          #83e460 43.07%,
          #efe755 61.69%,
          #df7c36 80.84%,
          #d24237 99.98%
        );
      }
    }
  }
`;

export const Copy = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-decoration: none;
  max-width: 50%;
  height: 100%;
  padding: 0 70px;
  box-sizing: border-box;
  font-family: 'BDRmono';
  font-size: 1rem;

  @media (max-width: 750px) {
    padding: 0 30px;
    width: 100%;
    max-width: none;
  }
`;

export const Txt = styled.div`
  font-size: 5em;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 24px;
  white-space: nowrap;
  text-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);

  @media (min-width: 1200px) {
    font-size: 5em;
  }

  @media (max-width: 600px) {
    font-size: 8vw !important;
  }

  @media (max-width: 330px) {
    font-size: 6.4vw;
  }

  ${({ cta }) =>
    cta &&
    css`
      font-family: 'Retro';
      position: absolute;
      bottom: 40px;
      font-size: 22px;

      @media (max-width: 750px) {
        font-size: 4.5vw !important;
      }

      @media (min-width: 1200px) {
        font-size: 22px;
      }
    `}
`;

export const MobilePromo = styled.div`
  display: none;
  @media (max-width: 700px) {
    display: block;
    background: linear-gradient(
      89.91deg,
      #6530cf 0.64%,
      #1032f2 23.92%,
      #83e460 43.07%,
      #efe755 61.69%,
      #df7c36 80.84%,
      #d24237 99.98%
    );
  }

  .orderWrapper {
    padding: 30px 0;
    text-align: center;
    color: #fff;
  }

  .orderTitle {
    font-family: 'GT America';
    font-weight: bold;
    font-style: italic;
    text-transform: uppercase;
  }

  .orderBtns {
    display: flex;
    justify-content: center;
    margin-top: 18px;
    a {
      margin: 0 10px;
      font-family: 'GT America';
      font-weight: bold;
      font-style: italic;
      background: #000;
      border-radius: 30px;
      padding: 10px;
      color: #fff;
      text-decoration: none;
      font-size: 0.65em;
      display: inline-block;
      max-width: 250px;
      width: calc(50% - 30px);
      text-transform: uppercase;
      transition: all 180ms ease-out;
      @media (max-width: 700px) {
        /* width: 100%;
        color: #000;
        padding: 0; */
      }
      &:hover {
        background: linear-gradient(
          89.91deg,
          #6530cf 0.64%,
          #1032f2 23.92%,
          #83e460 43.07%,
          #efe755 61.69%,
          #df7c36 80.84%,
          #d24237 99.98%
        );
      }
    }
  }
`;
